import { useMemo } from 'react';
import { dataLayer } from '@weatherbug/common';

const { AirQualityProvider } = dataLayer.providers;

export const useAirQualityProvider = (aqiBaseUrl: string, authId: string, secret: string) => {

    const aqiProvider = useMemo(() => {
        return new AirQualityProvider(aqiBaseUrl, authId, secret, undefined, undefined);
    }, [aqiBaseUrl, authId, secret]);

    const pollutantTypes = aqiProvider.getPollutantTypes();

    return { pollutantTypes };
};